import Swiper, {Pagination, Navigation} from 'swiper';
// import Swiper and modules styles
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

export default function ImmoExposeSwiper() {
    const element = document.querySelector('.i-js-expose-swiper');
    if (!element) return;
    const slidesCount = element.querySelector('.i-js-expose-swiper-wrapper').children.length;
    if (slidesCount >= 2) {
        // eslint-disable-next-line no-new, no-undef
        new Swiper(element, {
            modules: [Navigation, Pagination],
            direction: 'horizontal',
            pagination: {
                el: '.swiper-pagination',
            },
            centeredSlides: true,
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            spaceBetween: 20,
            keyboard: true,
            a11y: {
                prevSlideMessage: 'Zurück',
                nextSlideMessage: 'Nächste',
            },
        });
    }
}
